import Marketing_Banners from './components/Marketing_Banners';

export default Marketing_Banners;